<template>
  <section>
    <h2 class="mt-5">
      <i18n path="common.example" />
    </h2>
    <div class="p-3 border rounded-3 mt-3 shadow-sm">
      <v-page
        :total-row="21"
        align="center"
        @page-change="pageChange"
      />
    </div>

    <div class="text-center mt-2 font-monospace">
      <h3 class="my-4">
        <i18n path="page.demo.pageChangeLogs" />
      </h3>
      <div class="p-3 bg-light rounded-lg">
        <div
          v-for="(log, index) in pageMsg"
          :key="index"
        >
          {{ log }}
        </div>
      </div>
    </div>

    <showcode>
      <v-code>
        <pre>
        &lt;v-page :total-row="21" align="center" @page-change="pageChange"&gt;
        &lt;/v-page&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.gallery" />
      <small class="ms-3">
        <a
          href="https://codepen.io/terry05/pen/yjZYLR"
          target="_blank"
        >
          <i18n path="common.codePen" />
        </a>
      </small>
    </h4>

    <div class="d-flex flex-wrap border px-3 pt-3 pb-2 mb-3 rounded-lg shadow-sm">
      <div
        v-for="(num, index) in pageArr"
        :key="index"
        class="rounded-lg bg-light me-2 mb-2 text-black-50 display-3
        d-flex justify-content-center align-items-center"
        style="width: 10.9rem; height: 8rem;"
      >
        {{ num }}
      </div>
    </div>
    <div>
      <v-page
        :total-row="arr.length"
        align="left"
        @page-change="pagePhotoChange"
      />
    </div>

    <showcode>
      <v-code>
        <pre>
        &lt;template&gt;
          &lt;div&gt;
            &lt;div class="photo-wall"&gt;
              &lt;div v-for="num in pageArr" v-html="num" class="brick"&gt;&lt;/div&gt;
            &lt;/div&gt;
            &lt;v-page :total-row="arr.length" @page-change="pagePhotoChange"&gt;
            &lt;/v-page&gt;
          &lt;/div&gt;
        &lt;/template&gt;

        &lt;script&gt;
        export default {
          data () {
            return {
              arr: Array(108).fill(0).map((val, index) => index + 1),
              pageArr: []
            }
          },
          methods: {
            pagePhotoChange (pInfo) {
              let start=0, end=0
              start = pInfo.pageSize * (pInfo.pageNumber-1)
              end = start + pInfo.pageSize
              if(end > this.arr.length) end = this.arr.length

              this.pageArr.splice(0, this.pageArr.length)
              for (let i = start; i &lt; end; i++) {
                this.pageArr.push(this.arr[i])
              }
            }
          }
        }
        &lt;/script&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.complete" />
    </h4>
    <v-page
      align="left"
      :total-row="100"
      v-model="current"
      ref="page"
    />

    <div class="my-2 d-flex">
      <div class="col-md-1 me-3">
        <input
          type="text"
          class="form-control"
          v-model="target"
        >
      </div>
      <button
        class="btn btn-secondary me-3"
        type="button"
        @click="go"
      >
        forward
      </button>
      <button
        class="btn btn-outline-secondary"
        type="button"
        @click="current = current + 1"
      >
        page + 1 (v-model)
      </button>
    </div>

    <showcode>
      <v-code>
        <pre>
        &lt;v-page align="left" :total-row="100" v-model="current" ref="page"&gt;&lt;/v-page&gt;

        &lt;button class="btn btn-secondary" type="button" @click="go"&gt;forward&lt;/button&gt;
        &lt;button
          class="btn btn-outline-secondary"
          type="button"
          @click="current = current + 1"
        &gt;page + 1&lt;/button&gt;

        &lt;script&gt;
        export default {
          data () {
            return {
              current: 3
            }
          },
          methods: {
            go () {
              // use api to change current page
              this.$refs.page.goPage(3)
            }
          }
        }
        &lt;/script&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.noLength" />
    </h4>
    <v-page
      :total-row="100"
      align="left"
      :page-size-menu="false"
    />
    <showcode>
      <v-code>
        <pre>
        &lt;v-page :total-row="100" align="left" :page-size-menu="false"&gt;
        &lt;/v-page&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.noPageInfo" />
    </h4>
    <v-page
      :total-row="100"
      align="left"
      :page-size-menu="false"
      :info="false"
    />
    <showcode>
      <v-code>
        <pre>
        &lt;v-page :total-row="100" align="left" :page-size-menu="false" :info="false"&gt;
        &lt;/v-page&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.noFirstLast" />
    </h4>
    <v-page
      :page-size-menu="false"
      :info="false"
      :total-row="100"
      :first="false"
      :last="false"
      align="left"
    />
    <showcode>
      <v-code>
        <pre>
        &lt;v-page
          :page-size-menu="false"
          :info="false"
          :total-row="100"
          :first="false"
          :last="false"
          align="left"
        &gt;&lt;/v-page&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.noPageNumber" />
    </h4>
    <v-page
      :page-size-menu="false"
      :info="false"
      :total-row="100"
      :first="false"
      :last="false"
      :page-number="false"
      align="left"
    />
    <showcode>
      <v-code>
        <pre>
        &lt;v-page
          :page-size-menu="false"
          :info="false"
          :total-row="100"
          :first="false"
          :last="false"
          :page-number="false"
          align="left"
        &gt;&lt;/v-page&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.border" />
    </h4>
    <v-page
      align="left"
      :total-row="100"
      :border="true"
    />
    <showcode>
      <v-code>
        <pre>
        &lt;v-page :total-row="100" :border="true"&gt;
        &lt;/v-page&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.option.disabled" />
    </h4>
    <v-page
      :total-row="100"
      align="left"
      :disabled="disabled"
    />

    <div
      class="btn-group mt-2"
      role="group"
      aria-label="..."
    >
      <button
        type="button"
        class="btn btn-outline-dark"
        :disabled="!disabled"
        @click="disabled=false"
      >
        Enabled
      </button>
      <button
        type="button"
        class="btn btn-danger"
        :disabled="disabled"
        @click="disabled=true"
      >
        Disabled
      </button>
    </div>
    <showcode>
      <v-code>
        <pre>
        &lt;v-page :total-row="100" align="left" :disabled="disabled"&gt;
        &lt;/v-page&gt;

        &lt;div class="btn-group"&gt;
          &lt;button :disabled="!disabled" @click="disabled=false"&gt;Enabled&lt;/button&gt;
          &lt;button :disabled="disabled" @click="disabled=true"&gt;Disabled&lt;/button&gt;
        &lt;/div&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.displayAll" />
    </h4>
    <v-page
      align="left"
      :total-row="100"
      :display-all="true"
    />
    <showcode>
      <v-code>
        <pre>
        &lt;v-page
          :total-row="100"
          :display-all="true"
          @page-change="pageChange"
        &gt;
        &lt;/v-page&gt;

        &lt;script&gt;
        export default {
          methods: {
            pageChange (data) {
              // select 'All' item, the return data like below
              // { pageNumber: 1, pageSize: 0 }
              console.log(data)
            }
          }
        }
        &lt;/script&gt;
        </pre>
      </v-code>
    </showcode>

    <h4 class="mt-5">
      <i18n path="page.demo.scopedSlots" />
    </h4>
    <v-page
      align="left"
      :total-row="100"
      :border="true"
      v-slot="{ pageNumber, pageSize, isFirst }"
    >
      <div>
        current: {{ pageNumber }}
        size: {{ pageSize }}
        first: {{ isFirst }}
      </div>
    </v-page>
    <showcode>
      <v-code>
        <pre>
        &lt;v-page
          :total-row="100"
          :border="true"
          v-slot="{ pageNumber, pageSize, totalPage, totalRow, isFirst, isLast }"
        &gt;
          &lt;!-- scoped slot will output 6 page states --&gt;
          &lt;div&gt;
            page number: &lt;span v-text="pageNumber"&gt;&lt;/span&gt;
            page size: &lt;span v-text="pageSize"&gt;&lt;/span&gt;
            total page: &lt;span v-text="totalPage"&gt;&lt;/span&gt;
            total row: &lt;span v-text="totalRow"&gt;&lt;/span&gt;
            is first page: &lt;span v-text="isFirst"&gt;&lt;/span&gt;
            is last page: &lt;span v-text="isLast"&gt;&lt;/span&gt;
          &lt;/div&gt;
        &lt;/v-page&gt;
        </pre>
      </v-code>
    </showcode>
  </section>
</template>

<script>
export default {
  data () {
    return {
      arr: Array.apply(null, { length: 108 }).map((val, index) => index + 1),
      pageArr: [],
      pageMsg: [],
      disabled: false,
      target: 1,
      current: 3
    }
  },
  methods: {
    pageChange (pInfo) {
      this.pageMsg.push(pInfo)
    },
    pagePhotoChange (pInfo) {
      // console.log(pInfo);
      this.pageArr = []
      let start = 0; let end = 0
      start = pInfo.pageSize * (pInfo.pageNumber - 1)
      end = start + pInfo.pageSize - 1
      this.pageArr = this.arr.filter((val, idx) => idx >= start && idx <= end)
    },
    go () {
      this.$refs.page.goPage(Number(this.target))
    }
  }
}
</script>
